import { render, staticRenderFns } from "./WeeklyReportPage.vue?vue&type=template&id=133b4ddf&"
import script from "./WeeklyReportPage.vue?vue&type=script&lang=ts&"
export * from "./WeeklyReportPage.vue?vue&type=script&lang=ts&"
import style0 from "./WeeklyReportPage.vue?vue&type=style&index=0&id=133b4ddf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports